import { ErrorComponentModule } from './components/error/error.component.module';
import { ShareButtonComponentModule } from './components/share-button/share-button.component.module';
import { GamificationCelebrationComponentModule } from './components/gamification-celebration/gamification-celebration.component.module';
import { AboutComponentModule } from './components/about/about.component.module';
import { PermissionsOnboardingComponentModule } from './components/permissions-onboarding/permissions-onboarding.component.module';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from './pipes/PipesModule';
import { DirectivesModule } from './directives/DirectivesModule';

@NgModule({
	imports: [
		CommonModule,
		IonicModule,
		PipesModule,
		DirectivesModule,
		ErrorComponentModule,
		ShareButtonComponentModule,
		GamificationCelebrationComponentModule,
		AboutComponentModule,
		PermissionsOnboardingComponentModule
	],
	exports: [
		CommonModule,
		IonicModule,
		PipesModule,
		DirectivesModule,
		ErrorComponentModule,
		ShareButtonComponentModule,
		GamificationCelebrationComponentModule,
		AboutComponentModule,
		PermissionsOnboardingComponentModule
	]
})
export class SharedModule {}
